<template>
  <!-- 客服 -->
  <li class="lang usermenu" :class="'langs-' + current.lang">
    {{ current.text }}
    <div class="wrap-a1 popover popover-enter-to menubox">
      <ul class="list drama_list column dlime">
        <li class="wrapbg1" v-for="(vo, i) in languages" :key="i" @click="onLanguage(vo)">
          <div class="langs-img" :class="'langs-' + vo.lang" style="margin-right: 13px"></div>
          <div>
            {{ vo.text }}
          </div>
        </li>
      </ul>
      <!-- <button class="more" @click="onMoreHistofy()">{{ $t('_h._gd') }}</button> -->
    </div>
  </li>
</template>

<script>
import languages from '@/utils/languages'
import { getCurrentInstance } from 'vue'
import { setLangauge } from '@/utils/vue-i18n'
export default {
  name: 'languageVue',
  setup() {
    const { proxy } = getCurrentInstance()
    function change(language) {
      proxy.$i18n.locale = language.lang
      setLangauge(language)
      console.log('切换语言', language)
    }
    return { change }
  },
  data() {
    return {
      current: {},
      languages
    }
  },
  created() {
    const lang = localStorage.getItem(this.$Const.KEY_LANG)

    this.current = lang
      ? JSON.parse(lang)
      : {
          text: 'English',
          lang: 'en-us'
        }
  },
  methods: {
    onLanguage(item) {
      this.current = item
      localStorage.setItem(this.$Const.KEY_LANG, JSON.stringify(item))
      this.change(this.current)
      location.reload()
    }
  }
}
</script>

<style></style>
